module.exports = __webpack_public_path__ + "img/top-right-banner.c81b3cda.svg";